// planSets.ts — Patch 010.A.4 R7 split. Patch 012.A.2 plan_sets + extraction.

import { request } from './request'
import type {
  ExtractionStatus,
  PlanSetRow,
  PlanSetWithStatus,
  PlanSheetRow,
} from './types'

export const planSetsApi = {
  list: (projectId: string) =>
    request<{ ok: true; plan_sets: PlanSetWithStatus[]; count: number }>(
      `/api/projects/${encodeURIComponent(projectId)}/plan-sets`,
    ),
  get: (projectId: string, planSetId: string) =>
    request<{
      ok: true
      plan_set: PlanSetRow
      sheets: PlanSheetRow[]
      extraction_status: ExtractionStatus
      latest_extraction_at: string | null
      extraction_history: Array<{ request_id: string; created_at: string; source: string; action: string; notes: string | null }>
    }>(
      `/api/projects/${encodeURIComponent(projectId)}/plan-sets/${encodeURIComponent(planSetId)}`,
    ),
  create: (projectId: string, body: { version_label: string; document_id?: string | null; issued_date?: string | null; notes?: string | null }) =>
    request<{ ok: true; plan_set: PlanSetRow; request_id: string }>(
      `/api/projects/${encodeURIComponent(projectId)}/plan-sets`,
      { method: 'POST', body: JSON.stringify(body) },
    ),
  extract: (projectId: string, planSetId: string) =>
    request<{ ok: true; sheet_count: number; metadata: { prompt_version: string; cost_estimate_usd: number }; request_id: string }>(
      `/api/projects/${encodeURIComponent(projectId)}/plan-sets/${encodeURIComponent(planSetId)}/extract`,
      { method: 'POST', body: JSON.stringify({}) },
    ),
  remove: (projectId: string, planSetId: string) =>
    request<{ ok: true; plan_set_id: string; request_id: string }>(
      `/api/projects/${encodeURIComponent(projectId)}/plan-sets/${encodeURIComponent(planSetId)}`,
      { method: 'DELETE' },
    ),
}
